<template>
    <div>
        <div class="mb-2 flex items-center justify-end">
            <button
                @click="fetchUserAnalysis"
                :disabled="loading"
                class="flex items-center space-x-1 text-xs text-indigo-400 transition-colors hover:text-indigo-600 disabled:opacity-50 dark:text-indigo-400 dark:hover:text-indigo-300"
            >
                <ArrowPathIcon
                    :class="{ 'animate-spin': loading }"
                    class="h-3 w-3"
                />
                <span>{{ loading ? "Carregando..." : "Atualizar" }}</span>
            </button>
        </div>

        <ticto-loading v-if="loading" />

        <div
            v-else-if="!analysis"
            class="py-4 text-center text-gray-500 dark:text-gray-400"
        >
            Análise não disponível para este usuário
        </div>

        <div v-else class="rounded-lg bg-gray-50 p-3 dark:bg-gray-800">
            <div class="flex flex-col gap-2">
                <div class="flex items-center space-x-2">
                    <BoltIcon
                        v-tooltip="'Análise gerada por IA'"
                        class="h-5 w-5 text-purple-500"
                    />
                    <span
                        class="text-sm font-medium"
                        :class="{
                            'text-red-500': analysis.confidence < 30,
                            'text-yellow-500':
                                analysis.confidence >= 30 &&
                                analysis.confidence < 70,
                            'text-green-500': analysis.confidence >= 70,
                        }"
                    >
                        Confiança: {{ analysis.confidence }}%
                    </span>
                    <span
                        :class="{
                            'text-red-500': analysis.analysis === 'Reprovar',
                            'text-green-500':
                                analysis.analysis === 'Aprovar' ||
                                analysis.analysis === 'approved',
                            'text-yellow-500': analysis.analysis === 'Atenção',
                            'dark:text-white':
                                analysis.analysis === 'Análise manual',
                        }"
                        >{{ analysis.analysis }}</span
                    >
                </div>
                <div class="text-sm text-gray-400">
                    <TypewriterText :text="analysis?.reason" :speed="5" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { BoltIcon } from "@heroicons/vue/24/solid";
import { ArrowPathIcon } from "@heroicons/vue/24/outline";
import TypewriterText from "@/components/common/TypewriterText.vue";
import TictoLoading from "../layouts/TictoLoading.vue";

export default {
    props: {
        user: {
            type: Object,
            required: true,
        },
    },
    name: "UserSystemAnalysis",
    components: {
        BoltIcon,
        ArrowPathIcon,
        TypewriterText,
        TictoLoading,
    },

    data() {
        return {
            loading: false,
            analysis: null,
        };
    },

    mounted() {
        this.$nextTick(() => {
            this.fetchUserAnalysis();
        });
    },

    methods: {
        async fetchUserAnalysis() {
            if (!this.user?.id) return;

            this.loading = true;

            try {
                const { data } = await axios.get(
                    `/api/user/${this.user.id}/analysis`,
                );
                this.analysis = data.analysis || null;
            } catch (error) {
                console.error("Erro ao buscar análise do usuário:", error);
                this.analysis = null;
            } finally {
                this.loading = false;
                this.$emit("data-loaded", this.analysis);
            }
        },
    },

    watch: {
        analysis: {
            immediate: true,
            handler(newValue) {
                if (newValue) {
                    this.$nextTick(() => {
                        this.$emit("data-loaded", newValue);
                    });
                }
            },
        },
    },
};
</script>
